__webpack_require__.p = "https://assets-01.periodica.press/229c741-20524626526/";